// src/components/store/sections/newsletter/NewsletterV104SplitcardTealLagoon.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV104SplitcardTealLagoon(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={104}
      archKey="split_card"
      archLabel="Floating Split Card"
      palName="TealLagoon"
      grad="from-teal-500 via-cyan-600 to-emerald-700"
      lightBg="bg-teal-50"
      textCol="text-teal-700"
      borderCol="border-teal-200"
      btnCls="bg-teal-600 hover:bg-teal-700"
      hexCol="#14b8a6"
      {...props}
    />
  );
}
